export function buildYandexMapsPointUrl(lng: number, lat: number, zoom = 16): string {
  return `https://yandex.ru/maps/?pt=${lng},${lat}&z=${zoom}&l=map`
}

export function coordinatesToLngLat(
  coordinates: number[][] | undefined,
): { lng: number; lat: number } | null {
  if (!coordinates?.length) return null
  const first = coordinates[0]
  const pair: unknown = Array.isArray(first) && typeof first[0] === 'number' ? first : coordinates
  if (!Array.isArray(pair) || pair.length < 2) return null
  const lng = Number(pair[0])
  const lat = Number(pair[1])
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null
  return { lng, lat }
}
